module.exports = __webpack_public_path__ + "static/media/grid-item-b1.6bc2beec.png";